import { microwave } from '@round/api';
import { useCallback, useState } from 'react';

type FormStatus = microwave.PaymentRequestFormState | 'NOT_INITIALIZED' | 'LINK_BROKEN' | 'ERROR';

export type FormData = microwave.InviteForm;

export function useMicrosPaymentRequest(uuid: string | null | undefined) {
    const [data, setData] = useState<FormData | null>(null);
    const [error, setError] = useState<'LINK_BROKEN' | 'ERROR' | null>(null);

    const status: FormStatus = data?.form_state ? data.form_state : error ? error : 'NOT_INITIALIZED';

    const fetchData = useCallback(
        async (requestInit?: RequestInit) => {
            if (!uuid) {
                setError('LINK_BROKEN');
                return;
            }

            try {
                const response = await microwave.getInviteForm(uuid, requestInit);
                if (response.status === 404) {
                    setError('LINK_BROKEN');
                    return;
                }

                setData(response.data);
            } catch (error) {
                if (error instanceof Error && error.name === 'AbortError') {
                    return;
                }
                setError('ERROR');
            }
        },
        [uuid]
    );

    const updateFormData = useCallback((data: Partial<FormData>) => {
        setData((prev) => {
            if (!prev) {
                return prev;
            }
            return { ...prev, ...data };
        });
    }, []);

    return {
        data,
        status,
        error,

        init: useCallback((requestInit?: RequestInit) => fetchData(requestInit), [fetchData]),
        updateFormData,
    };
}
